export default "__VITE_PUBLIC_ASSET__380440ff__"